import React, { useState, useEffect } from "react";
import { withRouter, Link } from "react-router-dom";
import Hamburger from "./hamburger";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAlignRight,
  faWindowClose,
} from "@fortawesome/free-solid-svg-icons";
import { faGithub } from "@fortawesome/free-brands-svg-icons";
import BlurImage from "./BlurImage";

const Header = ({ history }) => {
  //state for menu button
  const [state, setState] = useState({
    initial: false,
    clicked: null,
    menuName: "Menu",
  });

  //state for disabled button
  const [disabled, setDisabled] = useState(false);

  //use Effect for page changes
  useEffect(() => {
    history.listen(() => {
      setState({ clicked: false, menuName: "Menu" });
    });
  });

  const handleMenu = () => {
    disabledMenu();
    if (state.initial === false) {
      setState({
        initial: null,
        clicked: true,
        menuName: "Close",
      });
    } else if (state.clicked === true) {
      setState({
        clicked: !state.clicked,
        menuName: "Menu",
      });
    } else if (state.clicked === false) {
      setState({
        clicked: !state.clicked,
        menuName: "Close",
      });
    }
  };

  //menu button should be disabled or not
  const disabledMenu = () => {
    setDisabled(!disabled);
    setTimeout(() => {
      setDisabled(false);
    }, 1200);
  };

  return (
    <header>
      <div className="header">
        <div className="header-line"></div>
        <div className="container">
          <div className="row v-center space-between">
            <div className="logo no-select">
              <Link to="/">
                <BlurImage
                  src={require("../assets/avatar.webp")}
                  alt="logo"
                  base64="data:image/webp;base64,UklGRowGAABXRUJQVlA4IIAGAAAwVQCdASrIAMgAPjEUh0KjIQxFgygYAYJaW0qmGT2SKcVp/AGmP/rn/vHz9N3r9n29Ay8zzinjD9N89Jm9q3VaKtWdAshT/9/HVTXoBCo5l5MnTGjjlPIvV/EE3AMRejiQLm46ZGO3Gbu7KJchP8Z/HvLVsFouBtKg8VWIX2O4HZV/zRYHFjTGMyZMGO9qeyRvc78TbFpEue1Xu5qtI9JEjvqVUkC89F8dRc0XKP1ILoNN2vC5F5kwrrCdiAjDKwBocw7sgjpjR0Z5+ER5hP6r4UxZIQ/htObDTNcc4wQNuXgyNGO6xNztwbywkB1HTlBo1EgDiyQ2q37dtKMKlOQ4qaBbUp9ijhPRzhHIj6bKvRdx/aMWjgG5DeuX4GlCE9/B+hk4U+7Fb6rOLj/jhk7SL0RfimPcZ3oVreYweEFEmuAYYufzGb9b+MO1Ki+oznRhBNUJCBKochaRZaau9ng2JKWNWO/iZbH+wn0LPvTRMaEdlTsgVtn0QMALj0uughe1sevox1ApZXa9a3R0EMva0x/vtDr7jDwYOXl5/JYJZDrydu/fV9cVvUz4FI2ZfWhINe7us1mQmNRmRm73AkBO5vXv63DJ6bJdFng9x+PXc2p9n5a2l6X7FhFm+89TQ9Dnh3hkLF7Ueq2zSxqSjUnb1DvvNoegPpUHkulo1CjAdsbRahLNGi5MXkd4oHsQITcoR3XbV59D9aqzXo2CKfh1ODDryKCCFboPbIxQLCzqVOycN073dz2ZaiPOMtLoq7oS/+A3XK0KCnYODV1rIv7BZJvVcmUPvRUjnRwMbVZVz+7JObVSajC5lqw2s2Dvl0GKW3wyg8S1zC6OV6rpGomDZqcl5H2e251rLQ6/wlkrn6UOJ0bp0lYg9CR741T5BlNcSEkV+Ib2HYGKoVLCbDjZ8AAAyHe/Q0as8UxRoPjPh+3nNm7TcpkiQcK8c/fAcCiU/hFhzNjfhaBmsdE6JJcyGgWY96TTj9N2w3qhvdg7fDsComfzn1jyKsnaQBOnzl4ghvfqtfTcHBSSv7QK/3vEwgxlIxDYARm5oG/j22yFNazllJwpfI1widaovgHxED14xwz6k7Pb2NLDzR7iXN7QEXPNzYVW1TEF0SElPPF1SLXUFmpdF80ykZwDDJxAbyBk6nTo77tEXUOFuAJPvhcXlqZpCGcDViMUewGOif46WTfL7sRBDjRdd9u8+fhMvc839Pmaw5iTL7nv83Y0KnHAssysekm5es/coYR9jG/coer7Z9/fRfpt5/h1WKGdxRIwGDSXnHG89GWba3j+7HTZJwYhjMGFksTwoMPdZEX7Rh/A6qpqy8oBIKCicAP2MBfmal5MtQic7HDO0qNJQLmM0pFij7rx/ZXubsQJiN/GZ9JTO52uiAqHPDFIrJnk9qMU/+zeBrFThSUJ76Xsu52AWrxhCbwB4HqEk7yzX26VZjLxaWUIzs0qXlWvAzpBHgYsdBazeRPQdjNCMg8RwF7FAyyxoJmnXB8hGpp1Pvtf3zYix3Vf8Tcz5BYuKJX+oGJi7GOYCmOd8ibiTesDSc+hucDBMFXutCY7vD6V57KWlT2+GW+3W9iafOJ/ogJxOdhScWxnASQ1yoQ9JOLna7hFdQPfE1UZPvBhMiHODLUHnomlPLDzEwzEM2dla5rRGSjPyaKiwUwQvt36+eBHA/29kj/NuMkNftCcqeX+CcQCP5HxryPSaAAOmUTPv6TAvWAQuXm6kCphDcs9tMl4TIYIE5ztyZAxJHScWuMDEqmldSNgiOwzfkha4q7lZoebXgWHuc3OPBQ1Ibo+2t189sqUTx9z3HX5KTBDtkivQN+4TKPEQi3npOcHYNKuRcYHdWbIWAjCy0G8l5/x/Vc5EadwK5SN2VR/9y7TbYh1ec8p8D9eQ7bJwkF0WoKLw51qxwlBW6tak7uhGNdBFixSfghipvCzi880HhCs0RRnflPpymAfwZphOJsh9DBwaEcRWjZPNmNYXqicT0kR5P32M7rwEx/2bMUEYmCuFzTg7WKgHWNHTYAfJVgQD44NafxVhxIhdzD3ItjvO4PE8g+wa+ZBv5MEcvr5BzLMmSr0w/ikMZGFWkepd0VIFwr43RCjKcVGCmAHtaTt8OB9EgZBxsA1bQkQ0kzWNn4MQ9GOfrbZaITQO6L1FgJsecpPoetvi7wyRCToMUphFERSxaAS8PVYU43vAk44VrI+9iA9cG6gAA=="
                />
              </Link>
            </div>
            <div className="nav-link">
              <a
                rel="noopener noreferrer"
                className="social"
                href="https://github.com/jaiswalvishal86"
                target="_blank"
              >
                <FontAwesomeIcon
                  icon={faGithub}
                  size="2x"
                />
              </a>
              <div
                className="link no-select"
                disabled={disabled}
                onClick={handleMenu}
              >
                {!state.clicked ? (
                  <FontAwesomeIcon
                    icon={faAlignRight}
                    size="2x"
                  />
                ) : (
                  <FontAwesomeIcon
                    icon={faWindowClose}
                    size="2x"
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <Hamburger state={state} />
    </header>
  );
};

export default withRouter(Header);
